import React from 'react'
import { FieldWrapper, Label, Select } from './Components'
import { LeftArrowIcon } from 'components_v2/Icons'
import { CustomOption, CustomSingleValue } from './Customselect/CustomSelect'
import BaseButton from './../Components/Common/Button'
import BaseInputText from './../Components/Common/TextInput'
import BaseSelectInput from '../Components/Common/SelectInput'

const findById = (list, id) =>
  list.find((option) => String(option.id) === String(id)) || null

const itemLabel = (type) => {
  if (type === 'bonus') return 'Bonus Item'
  if (type === 'series') return 'Series'
  return 'Class'
}

const SectionItem = ({
  itemIndex,
  item,
  setFieldValue,
  getClassListbyPlan,
  seriesItems,
  itemList,
  bonusItems,
  sectionIndex,
  remove,
  moveSectionIndex,
  errors,
  length
}) => {
  const field = (name) =>
    `sections[${sectionIndex}].items[${itemIndex}].${name}`
  const label = itemLabel(item.type)

  return (
    <div className='section-item'>
      <div className='section-item-heading'>
        <div className='section-item-title'>Item {itemIndex + 1}</div>
        <div className='section-item-actions'>
          {length > 1 && (
            <div className='item-order'>
              <button
                type='button'
                className='order-button up'
                disabled={itemIndex === 0}
                aria-label='Move item up'
                onClick={() => moveSectionIndex(itemIndex, itemIndex - 1)}
              >
                <LeftArrowIcon />
              </button>
              <button
                type='button'
                className='order-button down'
                disabled={itemIndex === length - 1}
                aria-label='Move item down'
                onClick={() => moveSectionIndex(itemIndex, itemIndex + 1)}
              >
                <LeftArrowIcon />
              </button>
              <FieldWrapper className='move-field'>
                <Label>Move to</Label>
                <Select
                  aria-label='Move item to position'
                  onChange={(e) => moveSectionIndex(itemIndex, e.target.value)}
                  value={itemIndex}
                >
                  {Array.from({ length }, (_, index) => (
                    <option key={index} value={index}>
                      {index + 1}
                    </option>
                  ))}
                </Select>
              </FieldWrapper>
            </div>
          )}
          <BaseButton
            className='remove-section-btn'
            onClick={() => remove(itemIndex)}
          >
            Remove item
          </BaseButton>
        </div>
      </div>

      <div className='align-items-center'>
        <FieldWrapper>
          <Label>Type</Label>
          <Select
            value={item.type}
            name={field('type')}
            onChange={(e) => {
              const { value } = e.target
              setFieldValue(field('type'), value)
              if (value !== 'class_from_another_series') {
                setFieldValue(field('series'), '')
              }
              setFieldValue(field('id'), '')
            }}
          >
            <option value='class'>Class</option>
            <option value='class_from_another_series'>
              Class from another series
            </option>
            {bonusItems.length > 0 && <option value='bonus'>Bonus</option>}
          </Select>
        </FieldWrapper>
        {item.type === 'class_from_another_series' && (
          <FieldWrapper>
            <Label>Series</Label>
            <BaseSelectInput
              value={item.series ? findById(seriesItems, item.series) : null}
              name={field('series')}
              options={seriesItems}
              placeholder='Select a series'
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.title}
              onChange={(value) => {
                const seriesId = value?.id || ''
                setFieldValue(field('series'), seriesId)
                setFieldValue(field('id'), '')
                if (seriesId) getClassListbyPlan(seriesId)
              }}
              components={{
                Option: CustomOption,
                SingleValue: CustomSingleValue
              }}
            />
          </FieldWrapper>
        )}
        <FieldWrapper>
          <Label>{label}</Label>
          <BaseSelectInput
            value={item.id ? findById(itemList, item.id) : null}
            name={field('id')}
            options={itemList}
            placeholder={`Select a ${label.toLowerCase()}`}
            disabled={
              (item.type === 'class_from_another_series' && !item.series) ||
              itemList.length === 0
            }
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.title}
            onChange={(value) => setFieldValue(field('id'), value?.id || '')}
            components={{
              Option: CustomOption,
              SingleValue: CustomSingleValue
            }}
          />
          {errors?.sections?.[sectionIndex]?.items?.[itemIndex]?.id && (
            <div className='text-danger'>
              Item is required
              {item.type === 'class_from_another_series' &&
                !item.series &&
                ' (pick a series first)'}
            </div>
          )}
        </FieldWrapper>
      </div>
      <div className='align-items-center'>
        <BaseInputText
          name={field('itemTag')}
          placeholder='Item tag'
          label='Tag'
        />
        <BaseInputText
          name={field('description')}
          placeholder='Item description'
          label='Description'
        />
      </div>
    </div>
  )
}

export default SectionItem
